const CHARS = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';

export function randomId(length: number = 7) {
    return Array.from({ length }, _ => randomChar()).join('');
}

export function randomChar() {
    return CHARS[Math.floor(Math.random() * CHARS.length)];
}
